import StudentAssignmentsPage from "./page"

export default StudentAssignmentsPage
